var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { isValidElement, useEffect, } from "react";
import Indicator from "../indicator/Indicator";
import { StyledTab, StyledTabContent } from "./Tab.style";
import { useTabsContext } from "./TabsContext";
export const isTabElement = (element) => {
    return isValidElement(element) && element.type === Tab;
};
const Tab = (_a) => {
    var _b;
    var { id, "data-insights": insightsAttr, selected = false, disabled = false, indicator, onSelected, label, children } = _a, rest = __rest(_a, ["id", "data-insights", "selected", "disabled", "indicator", "onSelected", "label", "children"]);
    const { selectedTab, setSelectedTab, tabPanels } = useTabsContext();
    useEffect(() => {
        if (selected) {
            setSelectedTab(id);
        }
    }, [id, selected]);
    const handleOnClick = () => {
        if (disabled) {
            return;
        }
        setSelectedTab(id);
        onSelected === null || onSelected === void 0 ? void 0 : onSelected();
    };
    const handleOnKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            setSelectedTab(id);
            onSelected === null || onSelected === void 0 ? void 0 : onSelected();
        }
    };
    return (React.createElement(StyledTab, Object.assign({ id: id, selected: !disabled && selectedTab === id, disabled: disabled, onClick: handleOnClick, onKeyDown: handleOnKeyDown, role: "tab", "aria-label": label, "aria-disabled": disabled, "aria-controls": ((_b = tabPanels.find((p) => p.tab === id)) === null || _b === void 0 ? void 0 : _b.id) || `panel-${id}`, "aria-selected": selectedTab === id, tabIndex: disabled ? -1 : 0, "data-insights": insightsAttr }, rest),
        React.createElement(StyledTabContent, { tabIndex: -1 },
            children,
            React.createElement(Indicator, { id: `${id}-indicator`, "data-insights": insightsAttr && `${insightsAttr}-indicator`, indicator: indicator }))));
};
export default Tab;
//# sourceMappingURL=Tab.js.map